export const SelectBoxFloating = (isSelectLP: boolean) => {
    return {
        option: (provided: any, state: any) => (
            {
                ...provided,
                borderBottom: '1px solid #F0FBFB',
                color: state.isSelected ? 'white' : '#3A3A3A',
                background: state.isSelected ? "#3CABF0" : "",
                padding: "10px 10px",
                ":hover": {
                    background: "##9ac7e2",
                },
                ":last-child": {
                    borderBottom: 'none',
                },
            }
        ),
        indicatorSeparator: (provided: any) => ({
            border: "none",
        }),
        container: (provided: any, state: any) => ({
            ...provided,
            outline: "none",
            padding: "0px 0px"
        }),
        control: (provided: any) => ({
            ...provided,
            borderRadius: "0px",
            marging: "0px",
            outline: "none",
            border: "none",
            "borderBottom": "1px solid #C4C4C4",
            boxShadow: "none",
            padding: "0px 0px",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "21px",
            color: "#3A3A3A",
            appearance: "none",
            "MozAppearance": "none",
            "WebkitAppearance": "none",
            position: "relative",
            width: "100%",
            whiteSpace: "no-wrap",
            height: "48px",
            ":focus": {
                outline: "none",
                border: "none",
                "borderBottom": isSelectLP ? "1px solid #3CABF0" : "1px solid #C4C4C4"
            },
            ":hover": {
                outline: "none",
                border: "none",
                "borderBottom": isSelectLP ? "1px solid #3CABF0":"1px solid #C4C4C4"
            },
        }),
        dropdownIndicator: (base: any, state: any) => ({
            ...base,
            ":before": {
                border: "1px solid #C4C4C4",
            },
            ":hover": {
                color: "#C4C4C4",
            },
            "svg": {
                height: 25,
                width: 25,
            },
            padding: "0px",
            fontFamily: "Font Awesome 6 Free",
            fontWeight: 900,
            fontSize: "14px",
            color: "#C4C4C4",
            transition: "all .2s ease",
            transform: state.selectProps.menuIsOpen ? "rotate(0deg)" : "rotate(-90deg)",
        }),
        // dropdownIndicator: (provided:any)=>({
        //     ":before": {
        //         border: "none",
        //     },
        //     fontFamily: "Font Awesome 6 Free",
        //     fontWeight: 900,
        //     fontSize: "14px",
        //     color: "#66CFC8",
        // }),
        menu: (provided: any, state: any) => (
            {
                ...provided,
                width: "100%",
                color: state.selectProps.menuColor,
                padding: 10,
                borderRadius: "15px",
                left: 0,
                background: "#FFFFFF",
                boxShadow: "0px 12px 30px 8px rgba(0, 0, 0, 0.15)",
                zIndex: "999",
            }
        ),
        menuList: (provided: any,) => ({
            ...provided,
            maxHeight: "150px",
            scrollbarWidth: "thin",
            "paddingRight": "16px"
        }),
        singleValue: (provided: any, state: any) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';
            return { ...provided, opacity, transition };
        },
        input: (base: any) => ({
            ...base,
            ...(isSelectLP ? { color: "#3CABF0 !important"}: {})
        }),
        valueContainer: (provided: any, state: any) => ({
            ...provided,
            overflow: "visible",
            padding: "0px 0px"
        }),
        placeholder: (provided: any, state: any) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "30%",
            transition: "top 0.1s, font-size 0.1s",
            lineHeight: "16px",
            fontSize: (state.hasValue || state.selectProps.inputValue) ? 12 : 16
        }),
    }
}